import script from "./Cooperate.vue?vue&type=script&setup=true&lang=js"
export * from "./Cooperate.vue?vue&type=script&setup=true&lang=js"

import "./Cooperate.vue?vue&type=style&index=0&id=40730830&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40730830"]])

export default __exports__